import { render, staticRenderFns } from "./WineryWelcome.vue?vue&type=template&id=1db95088&scoped=true&"
import script from "./WineryWelcome.vue?vue&type=script&lang=js&"
export * from "./WineryWelcome.vue?vue&type=script&lang=js&"
import style0 from "./WineryWelcome.vue?vue&type=style&index=0&id=1db95088&prod&lang=css&"
import style1 from "./WineryWelcome.vue?vue&type=style&index=1&id=1db95088&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db95088",
  null
  
)

export default component.exports